<template>
  <div>
    <v-row
      class="pr-5"
      justify="end"
      align="center"
      dense>
      <v-col cols="3">
        <slot name="facilityName">
          <v-text-field
            :value="facilityName"
            label="施設名"
            filled
            readonly
            hide-details
            dense />
        </slot>
      </v-col>
      <v-col cols="2">
        <v-text-field
          :value="roomFloor(value)"
          label="階数"
          filled
          readonly
          hide-details
          dense />
      </v-col>
      <v-col cols="2">
        <v-text-field
          :value="roomName"
          label="部屋名"
          filled
          readonly
          hide-details
          dense />
      </v-col>
      <v-col cols="2">
        <v-text-field
          :value="value.room_no"
          label="部屋No"
          filled
          readonly
          hide-details
          dense />
      </v-col>
      <v-col cols="1">
        <v-text-field
          :value="completionYear"
          label="新築竣工年"
          filled
          readonly
          hide-details
          dense />
      </v-col>
      <v-col cols="1">
        <v-text-field
          :value="renovationYear1"
          label="改修年①"
          filled
          readonly
          hide-details
          dense />
      </v-col>
      <v-col cols="1">
        <v-text-field
          :value="renovationYear2"
          label="改修年②"
          filled
          readonly
          hide-details
          dense />
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'RoomHeader',
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    facilityName: {
      type: String,
      default: null,
    },
    survey: {
      type: String,
      default: null,
    },
  },
  computed: {
    completionYear() {
      return this.survey === 'written' ? this.value.completion_year : this.value.field_completion_year
    },
    roomName() {
      return this.survey === 'written'
        ? this.value.room_name
        : this.value.field_room_name
    },
    renovationYear1() {
      return this.survey === 'written'
        ? this.value.renovation_year1 || ' '
        : this.value.field_renovation_year1 || ' '
    },
    renovationYear2() {
      return this.survey === 'written'
        ? this.value.renovation_year2 || ' '
        : this.value.field_renovation_year2 || ' '
    },
    roomFloor: () => ({ floors }) => {
      if (floors === 99) {
        return 'RF'
      }
      if (Math.sign(floors) === -1) {
        return `B${Math.abs(floors)}`
      }
      return `${floors}F`
    },
  },
}
</script>
